import { Typography, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';

const BlockedInput = ({ text }) => {
  const theme = useTheme();

  return (
    <Box
      pt={0}
      m={0}
      maxWidth="sm"
      sx={{
        margin: '0 auto', // This will horizontally center the form
        textAlign: 'center' // This will center the content inside the form
      }}
    >
      <Typography variant="h5" color={theme.palette.primary.main} pb={1} mt={0}>
        {text}
      </Typography>

      <LinearProgress
        color="primary"
        sx={{
          '& .MuiLinearProgress-bar': {
            // apply a new animation-duration to the `.bar` class
            animationDuration: '5s'
          }
        }}
      />
    </Box>
  );
};

export default BlockedInput;
